
import { Component, Vue } from 'vue-property-decorator';
import { getCloudComputerTip, postAddCloudComputerTip } from '@/api/cloud-computer-tip';
import { toast } from '@/utils/common';
import { iCloudComputerTip } from '@/interface/cloud-computer-tip';
import { VueEditor } from 'vue2-editor';
@Component({ components: { VueEditor } })
export default class extends Vue {
  isLoading = false;
  model: iCloudComputerTip = {
    switch: true,
    title: '',
    content: '',
    count_down: 5,
  };
  customToolbar = [
    ['bold', 'italic', 'underline'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
    [{ color: [] }],
    [{ indent: '-1' }, { indent: '+1' }],
  ];
  errMsg: string = '';
  rules: any = {
    switch: [{ required: true, message: '请选择开关', trigger: 'blur' }],
    title: [{ required: true, message: '请输入12个字以内', trigger: 'blur' }],
    content: [{ required: true, message: '请输入提示内容', trigger: 'blur' }],
    count_down: [{ required: true, message: '请输入大于等于5的整数', trigger: 'blur' }],
  };
  handleChangeSwitch() {
    let list: Array<string> = Object.values(this.rules);
    for (let item of list) {
      (item[0] as any).required = this.model.switch;
    }
  }

  async submitForm(formName: string) {
    try {
      (this.$refs[formName] as any).validate((valid: any) => {
        if (valid) {
          this.isLoading = true;
          //开始操作
          this.addCloudComputerTip();
        }
      });
    } catch (err) {
      console.log(err);
    } finally {
      this.isLoading = false;
    }
  }
  async addCloudComputerTip() {
    const res = await postAddCloudComputerTip(this.model);
    if (res.code == 0) {
      toast('操作成功！');
      this.getInfo();
    } else {
      toast(res.msg, 'error');
    }
  }
  //获取初始值
  async getInfo() {
    try {
      const res = await getCloudComputerTip();
      this.model = res.data;
      this.handleChangeSwitch();
    } catch (ex) {
      console.log(ex);
    }
  }
  mounted() {
    this.getInfo();
  }
}
